module.exports = __webpack_public_path__ + "static/img/house-min.68c17ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/min/house-min.jpg
// module id = XbTu
// module chunks = 1